export default __webpack_public_path__ + "static/media/nature.3dcbe78d.mp3";